module.exports = __webpack_public_path__ + "img/wechat.f5f05338.png";